import Vue from "vue";
import store from "@/store";
Vue.directive("permission", {
  bind(el, binding, vnode) {
    const { value } = binding;
    // const roles = store.getters && store.getters.roles;
    const roles = store.state.roles;
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value;
      const hasPermission = roles.some(role => {
        return permissionRoles.includes(role);
      });
      if (!hasPermission) {
        el.onclick = function() {
          store.commit("setLoginVisible", true);
        };
      }else{
        el.onclick = null
        store.commit('checkUserStatus');
      }
    } else {
      throw new Error(`need roles! Like v-permission="['admin','editor']"`);
    }
  },
  update(el, binding, vnode){
    const { value } = binding;
    const roles = store.state.roles;
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value;
      const hasPermission = roles.some(role => {
        return permissionRoles.includes(role);
      });
      if (hasPermission) 
        el.onclick = null
      
    } else {
      throw new Error(`need roles! Like v-permission="['admin','editor']"`);
    }
  }
});
